import { FormHelperText, FormLabel, Stack } from '@mui/material';
import { CompactPicker } from 'react-color';
import { Controller, FieldValues } from 'react-hook-form';

import { BaseInputProps } from './GetFormInput';

export function FormColorPicker<T extends FieldValues>({
    control,
    helperText,
    label,
    required,
    value,
}: Readonly<BaseInputProps<T>>) {
    return (
        <Stack spacing={1}>
            {label ? (
                <FormLabel required={required} sx={{ color: 'black', fontWeight: 'medium', mb: 0.5 }}>
                    {label}
                </FormLabel>
            ) : null}
            <Controller
                control={control}
                name={value}
                render={({ field: { onChange, value }, fieldState: { error } }) => (
                    <Stack
                    // Apply custom styles to the compact color picker
                    // sx={{
                    //     '& .compact-picker': {
                    //         color: '#fff !important',
                    //         width: '100% !important',
                    //     },
                    // }}
                    >
                        <CompactPicker
                            color={value as string}
                            colors={colors}
                            onChange={(color) => onChange(color.hex)}
                        />
                        {helperText || error ? (
                            <FormHelperText error={!!error}>{error ? error.message : helperText}</FormHelperText>
                        ) : null}
                    </Stack>
                )}
                rules={{
                    required: required ? `${label ?? value} cannot be empty` : false,
                }}
            />
        </Stack>
    );
}

const colors = [
    '#4D4D4D',
    '#999999',
    '#FFFFFF',
    '#F44E3B',
    '#FE9200',
    '#FCDC00',
    '#DBDF00',
    '#A4DD00',
    '#68CCCA',
    '#73D8FF',
    '#AEA1FF',
    '#FDA1FF',
    '#333333',
    '#808080',
    '#cccccc',
    '#D33115',
    '#E27300',
    '#FCC400',
    '#B0BC00',
    '#68BC00',
    '#16A5A5',
    '#009CE0',
    '#7B64FF',
    '#FA28FF',
    '#000000',
    '#666666',
    '#B3B3B3',
    '#9F0500',
    '#C45100',
    '#FB9E00',
    '#808900',
    '#194D33',
    '#0C797D',
    '#0062B1',
    '#653294',
    '#AB149E',
];
